import VerzoekOmWijziging from '../types/VerzoekOmWijziging';
import { Get } from './helpers/builder';

export const vowList =
	Get`/lists/providers/${'provider'}/list/changereqs`.json<{ response: VerzoekOmWijziging[] }>();

export const vowListInProgress =
	Get`/changereqs/providers/${'provider'}/clients/${'client'}/status`.json<{ response: VerzoekOmWijziging[] }>();
